import {ShowCargaMasivaModalForm} from './ShowCargaMasivaModalForm'

const ShowCargaMasivaModalFormWrapper = () => {
  return <ShowCargaMasivaModalForm />
}

export {ShowCargaMasivaModalFormWrapper}
